const courseImage = [
    { "courseId": 1, "posterLink": "https://www.growniverse.com/images//c1.webp" },
    { "courseId": 2, "posterLink": "https://www.growniverse.com/images//c2.webp" },
    { "courseId": 3, "posterLink": "https://www.growniverse.com/images//c3.webp" },
    { "courseId": 4, "posterLink": "https://www.growniverse.com/images//c4.webp" },
    { "courseId": 5, "posterLink": "https://www.growniverse.com/images//c5.webp" },
    { "courseId": 6, "posterLink": "https://www.growniverse.com/images//c6.webp" },
    { "courseId": 7, "posterLink": "https://www.growniverse.com/images//c7.webp" },
    { "courseId": 8, "posterLink": "https://www.growniverse.com/images//c8.webp" },
    { "courseId": 9, "posterLink": "https://www.growniverse.com/images//c9.webp" },
    { "courseId": 10, "posterLink": "https://www.growniverse.com/images//c10.webp" },
    { "courseId": 11, "posterLink": "https://www.growniverse.com/images//c11.webp" },
    { "courseId": 12, "posterLink": "https://www.growniverse.com/images//c12.webp" },
    { "courseId": 13, "posterLink": "https://www.growniverse.com/images//c13.webp" },
    { "courseId": 14, "posterLink": "https://www.growniverse.com/images//c14.webp" },
    { "courseId": 15, "posterLink": "https://www.growniverse.com/images//c15.webp" },
    { "courseId": 16, "posterLink": "https://www.growniverse.com/images//c16.webp" },
    { "courseId": 17, "posterLink": "https://www.growniverse.com/images//c17.webp" },
    { "courseId": 18, "posterLink": "https://www.growniverse.com/images//c18.webp" },
    { "courseId": 19, "posterLink": "https://www.growniverse.com/images//c19.webp" },
    { "courseId": 20, "posterLink": "https://www.growniverse.com/images//c20.webp" },
    { "courseId": 21, "posterLink": "https://www.growniverse.com/images//c21.webp" },
    { "courseId": 22, "posterLink": "https://www.growniverse.com/images//c22.webp" },
    { "courseId": 23, "posterLink": "https://www.growniverse.com/images//c23.webp" },
    { "courseId": 24, "posterLink": "https://www.growniverse.com/images//c24.webp" },
    { "courseId": 25, "posterLink": "https://www.growniverse.com/images//c25.webp" },
    { "courseId": 26, "posterLink": "https://www.growniverse.com/images//c26.webp" },
    { "courseId": 27, "posterLink": "https://www.growniverse.com/images//c27.webp" },
    { "courseId": 28, "posterLink": "https://www.growniverse.com/images//c28.webp" },
    { "courseId": 29, "posterLink": "https://www.growniverse.com/images//c29.webp" },
    { "courseId": 30, "posterLink": "https://www.growniverse.com/images//c30.webp" },
    { "courseId": 31, "posterLink": "https://www.growniverse.com/images//c31.webp" },
    { "courseId": 32, "posterLink": "https://www.growniverse.com/images//c32.webp" },
    { "courseId": 33, "posterLink": "https://www.growniverse.com/images//c33.webp" },
    { "courseId": 100, "posterLink": "https://www.growniverse.com/images//c100.webp" },
];
export default courseImage;